<template>
    <div class="page-support">
        <!--content-->
        <SupportList />
        <div class="container">
            <div class="single">
                <div class=" single-grid">

                    <div class="tit">前言</div>

                    <p>非常感激每一位打赏的朋友！我们会努力收集更多好玩的游戏。赞助所得将用于服务器以及域名费用。</p>
                    <p>温馨提示：赞助请务必备注一下，方便我们把您记录在这个列表里~</p>
                    <p></p>

                    <div class="tit">其它</div>
                    <div class="btn-group">
                        <a :href="settingList.article_qqurl" :title="settingList.article_qqtip" class="cd-read-more  hvr-wobble-top btn-info" target="_blank">{{settingList.article_qqbtn}}</a>
                        <a href="javascript:void(0)" title="您的支持，是我最大的动力！" class="cd-read-more  hvr-wobble-top btn-info btn-dashang" @click="open()">我要赞助</a>

                    </div>
                    <div class="tit">赞助支持者列表</div>
                    <table class="my-table">
                        <tr>
                            <th>日期</th>
                            <th>赞助支持者</th>
                            <th>赞助方式</th>
                            <th>金额(元)</th>
                        </tr>
                        <tr v-for="(s, index) in gameData" :key="index">
                            <td>{{s.date}}</td>
                            <td>{{s.name}}</td>
                            <td>{{s.payment}}</td>
                            <td>{{s.amount}}</td>
                        </tr>
                        <!-- <tr>
                            <td colspan="2">总计</td>
                            <td colspan="2">{{total2.toFixed(2)}} 元</td>
                        </tr> -->

                    </table>

          <el-pagination
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[12, 30, 50, 100]"
              :page-size="pagesize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total">
          </el-pagination>
                </div>

            </div>
        </div>

        <!--//content-->
        <!--images-->
        <div class="container">
            <div class="games">
                <!--					<div class="tit">游戏图鉴</div>-->
                <section style="display: none">
                </section>

            </div>
        </div>
        <!--//images-->
    </div>
</template>
<script>
import SupportList from '@/components/Support.vue'
export default {
  name: 'Support',
  components: {
    SupportList
  },
  data() {
    return {
      total: 0,
      currentPage: 1,
      pagesize: 12,
      gameList: [],
      settingList: [],
      total2: 0
    }
  },
  created() {
    this.getData()
    this.getSupportSetting()
  },
  mounted() {},
  computed: {
    gameData() {
      return this.gameList.slice((this.currentPage - 1) * this.pagesize, this.currentPage * this.pagesize)
    }
  },
  methods: {
    getData() {
      const timeStamp = new Date().getTime()
      this.$http.get('static/data/support.json' + '?' + timeStamp).then(game => {
        this.gameList = game.data
        this.total = this.gameList.length
        this.total2 = game.data.reduce((sum, item) => sum + item.amount, 0)
      })
    },
    getSupportSetting() {
      if (localStorage.getItem('settingList')) {
        this.settingList = JSON.parse(localStorage.getItem('settingList'))[0]
      } else {
      var timeStamp = new Date().getTime()
      this.$http.get('static/data/setting.json' + '?' + timeStamp).then(res => {
        this.settingList = res.data[0]
        this.colorList = res.data[0].article_colorList
      },
      res => {
        console.log('error')
      }
      )
      }
    },
    open() {
      $('.hide_box').fadeIn()
      $('.shang_box').fadeIn()
    },
    handleSizeChange(size) {
      this.pagesize = size
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage
    }

  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
